var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mainGraphPane",attrs:{"id":"mainGraphPane"}},[_c('div',{ref:"mountNode",attrs:{"id":"mountNode"}})])}
var staticRenderFns = []

export { render, staticRenderFns }